var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#EAEFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_436_9878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 14.5C20.6569 14.5 22 13.1569 22 11.5C22 9.84315 20.6569 8.5 19 8.5C17.3431 8.5 16 9.84315 16 11.5C16 13.1569 17.3431 14.5 19 14.5Z",
    fill: "#0236C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 31.5C27.586 31.5 27.25 31.164 27.25 30.75V24.5C27.249 23.81 26.69 23.251 26 23.25C25.586 23.25 25.25 22.914 25.25 22.5C25.25 22.086 25.586 21.75 26 21.75C27.518 21.751 28.749 22.982 28.75 24.5V30.75C28.75 31.164 28.414 31.5 28 31.5Z",
    fill: "#0236C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7074 25.793L20.3424 23.428C20.1274 24.086 19.6914 24.649 19.1074 25.021L20.8934 26.807L20.0304 30.257C19.8964 30.793 20.2224 31.336 20.7584 31.47C21.2944 31.604 21.8374 31.278 21.9714 30.742L22.9714 26.741C23.0564 26.4 22.9564 26.04 22.7084 25.792L22.7074 25.793Z",
    fill: "#0236C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7128 22.201C25.0998 21.807 25.0938 21.174 24.6998 20.787L19.8788 16.058C19.2938 15.49 18.4188 15.341 17.6788 15.684L13.5788 17.594C13.3378 17.706 13.1518 17.91 13.0618 18.16L11.6218 22.158C11.4348 22.678 11.7048 23.251 12.2248 23.437C12.7438 23.624 13.3168 23.354 13.5038 22.834L14.8008 19.228L16.2508 18.552L15.5398 22.105C15.4748 22.436 15.4958 22.778 15.6008 23.098L16.9008 27.344L15.1688 29.943C14.8628 30.403 14.9868 31.023 15.4458 31.33C15.9058 31.637 16.5268 31.512 16.8328 31.053L18.8308 28.056C18.9998 27.803 19.0448 27.488 18.9548 27.198L18.0878 24.404C18.7888 24.191 19.3168 23.61 19.4618 22.891L20.2048 19.173L23.3008 22.212C23.6948 22.599 24.3278 22.593 24.7148 22.199L24.7128 22.201Z",
    fill: "#0236C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_436_9878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon-6.7df94abafe738bd7b7526b2730ce4ebb.svg";
export { ForwardRef as ReactComponent };